module.exports = __webpack_public_path__ + "img/logo.a61da306.svg";